import { DrawLineStringMode } from '@nebula.gl/edit-modes';

export default class DrawLimitedLineStringMode extends DrawLineStringMode {
    handleClick(event, props) {
        const { modeConfig = {}, features } = props;

        const maxPoints = modeConfig.maxPoints || 2;
        if (event.picks.length && event.picks[0].object.geometry.coordinates.length >= maxPoints) {
            // If max points reached, finalize drawing
            if (props.onEdit) {
                props.onEdit({
                    editType: 'addFeature',
                    updatedData: {
                        ...props.data,
                        features: [...props.data.features, event.picks[0].object],
                    },
                    editContext: {
                        featureIndex: 0,
                    },
                });
            }
            return null;
        }

        // Continue with normal drawing
        return super.handleClick(event, props);
    }
}
